import PropTypes from 'prop-types';
import React from 'react';

import TaskRow from '../TaskRow';
import TaskTableHeader from '../TaskTableHeader';
import { TopicBand } from '../Visit';
import styles from './MemberRecord.module.scss';
import { taskDoneDate } from './memberRecordModel';

const MemberTasks = ({
  model,
  showCompleted,
  hasUpcoming,
  onOpenTask,
  onAssignToMe,
  assigningIds,
}) => {
  const completed = [...model.doneTasks].sort((a, b) =>
    taskDoneDate(b).localeCompare(taskDoneDate(a)),
  );

  return (
    <div className={styles.tasksTab}>
      <div className={styles.listCard}>
        <TopicBand
          headingLevel="h3"
          label="Open"
          meta={hasUpcoming ? 'Before next visit' : undefined}
        />
        {model.openTasks.length > 0 ? (
          <>
            <TaskTableHeader />
            {model.openTasks.map((task) => (
              <TaskRow
                key={task.id}
                task={task}
                onSelect={() => onOpenTask(task)}
                onAssignToMe={onAssignToMe}
                isAssigning={assigningIds.has(task.id)}
              />
            ))}
          </>
        ) : (
          <div className={styles.emptyNote}>No open tasks.</div>
        )}
      </div>
      {showCompleted && completed.length > 0 && (
        <div className={styles.listCard}>
          <TopicBand headingLevel="h3" label="Completed" meta="Full journey" />
          {completed.map((task) => (
            <TaskRow key={task.id} task={task} compact onSelect={() => onOpenTask(task)} />
          ))}
        </div>
      )}
    </div>
  );
};

MemberTasks.propTypes = {
  model: PropTypes.object.isRequired,
  showCompleted: PropTypes.bool,
  hasUpcoming: PropTypes.bool,
  onOpenTask: PropTypes.func.isRequired,
  onAssignToMe: PropTypes.func.isRequired,
  assigningIds: PropTypes.instanceOf(Set).isRequired,
};

export default MemberTasks;
